import React from "react";
import theme from "app/Theme/Theme";
import Svg, {
  Circle,
  Defs,
  LinearGradient,
  Path,
  Stop,
} from "react-native-svg";
import normalize from "app/utils/normalize";

const StepCommentNotification = ({
  height = normalize(24),
  width = normalize(24),
  color = theme.colors["neutral.white"],
  ...props
}) => (
  <Svg
    width={height}
    height={width}
    {...props}
    preserveAspectRatio="xMidYMin meet"
    viewBox="0 0 24 24"
  >
    <Circle cx={12} cy={12} r={12} fill="#007EFC" />
    <Circle cx={12} cy={12} r={12} fill="url(#StepCommentNotification1)" />
    <Path
      d="M15.121 7.917H8.44c-.612 0-1.106.493-1.106 1.105v4.422c0 .612.494 1.106 1.106 1.106h.368v1.106c0 .266.276.459.546.324.007-.008.022-.008.03-.015 2.027-1.36 1.572-1.056 2.026-1.356a.37.37 0 0 1 .2-.059h3.512c.612 0 1.106-.494 1.106-1.106V9.023c0-.612-.494-1.105-1.106-1.105Zm-2.948 4.422H9.176c-.486 0-.488-.737 0-.737h2.997c.486 0 .488.737 0 .737Zm2.211-1.474H9.176c-.486 0-.488-.737 0-.737h5.208c.486 0 .488.737 0 .737Z"
      fill={color}
    />
    <Defs>
      <LinearGradient
        id="StepCommentNotification1"
        x1={12}
        y1={0}
        x2={12}
        y2={24}
        gradientUnits="userSpaceOnUse"
      >
        <Stop offset="0" stopColor="#FFCC49" />
        <Stop offset="1" stopColor="#EDB900" />
      </LinearGradient>
    </Defs>
  </Svg>
);

export default StepCommentNotification;
